import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdReportFormat, EdReportJob, EdReportType, EdReportsApi } from '../tokens/ed-reports.token';

/**
 * REST implementation of the E-D Reports API (PRD §3.9, EM-838) — true async jobs.
 *
 *   POST /services/embedded/api/v1/ed/reports/{type}?format=  → PENDING job
 *   GET  /services/embedded/api/v1/ed/reports/jobs/{jobId}    → poll status
 *   GET  /services/embedded/api/v1/ed/reports/jobs/{jobId}/download → Blob
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_REPORTS.
 */
@Injectable({ providedIn: 'root' })
export class EdReportsRestService implements EdReportsApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/reports`;

  requestReport(type: EdReportType, format: EdReportFormat): Observable<EdReportJob> {
    return this.http.post<EdReportJob>(`${this.base}/${type}?format=${format}`, {});
  }

  getJob(jobId: string): Observable<EdReportJob> {
    return this.http.get<EdReportJob>(`${this.base}/jobs/${jobId}`);
  }

  downloadJob(jobId: string): Observable<Blob> {
    return this.http.get(`${this.base}/jobs/${jobId}/download`, { responseType: 'blob' });
  }
}
